var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"foot",class:_vm.type == 'REISTER' ? '' : 'fixed'},[_c('div',{staticClass:"footText"},[_vm._v(_vm._s(_vm.$t('components.foot1.text1')))]),_c('div',{staticClass:"footText"},[_vm._v(_vm._s(_vm.$t('components.foot1.text2')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }